import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";
import moment from "moment";

import { PieChart } from "react-native-svg-charts";

import AppTheme from "../../AppTheme";
import { HomeCardGroups } from "../../../../helpers/utils.js";

import NewElementIcon from "../../common/ActionsMenuButton/icons/NewElementIcon";
import CloseIcon from "../../common/dialog/CloseIcon";
import cardStyles from "./cardStyles";
import ImageComponent from "../../common/ImageComponent.js";
import CardUtils from "./CardUtils";

const NUM_TEXT_LINES = 10;

export default function ManaScoreCard({
  controller,
  data,
  isSnoozed = false,
  onSnooze = null,
}) {
  const [showCard, setShowCard] = useState(false);
  const [numberOfLines, setNumberOfLines] = useState(NUM_TEXT_LINES);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const toggleTextView = () => {
    setNumberOfLines(numberOfLines == NUM_TEXT_LINES ? 30 : NUM_TEXT_LINES);
  };

  let { score, text, start_day, end_day } = data || {};

  const from = moment(start_day).format("MMM D");
  const to = moment(end_day).format("MMM D");
  const intervalText = from === to ? from : from + " - " + to;

  let hasHours = false;
  const groups = HomeCardGroups;
  const pieData = Object.keys(groups).map((key, index) => {
    if (data[`${key}_total`] > 0) hasHours = true;

    return {
      key: `pie-${index}`,
      value: data[`${key}_total`] || 0,
      svg: {
        fill: groups[key].color,
      },
    };
  });

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, styles.card]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />

        <View style={styles.content}>
          {/* Text */}
          <View style={{ flex: 1 }}>
            {/* Header */}
            <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
              <NewElementIcon width={20} height={20} />

              <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
                <Text style={[cardStyles.title]}>Mana Score</Text>
                <Text style={cardStyles.date}>{intervalText}</Text>
              </View>
            </View>

            <Text
              style={styles.description}
              numberOfLines={numberOfLines}
              onPress={toggleTextView}
            >
              {text}
            </Text>
          </View>

          {/* Chart */}
          {hasHours ? (
            <View style={styles.mediaContainer}>
              <PieChart
                style={styles.chart}
                data={pieData}
                innerRadius={"60%"}
                outerRadius={"100%"}
                sort={(a, b) => (b.key < a.key ? 1 : -1)}
              />

              <View style={styles.scoreContainer}>
                <Text style={styles.score}>{score}</Text>
              </View>
            </View>
          ) : (
            /* No hours score */
            <View style={styles.mediaContainer}>
              <ImageComponent
                image={require("../../../../assets/home/HoursPanel.png")}
                style={styles.headerBg}
              />

              <View style={styles.scoreContainer}>
                <Text style={[styles.score, { color: "#FFF" }]}>{score}</Text>
              </View>
            </View>
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    paddingVertical: 0,
    minHeight: 116,
    paddingHorizontal: 8,
    paddingBottom: 6,
  },
  content: {
    width: "100%",
    //height: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  mediaContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 116,
    width: 100,
  },
  chart: {
    width: 100,
    height: 100,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  scoreContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  score: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 26,
    lineHeight: 35,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
